import styled, { createGlobalStyle } from 'styled-components';
import { DndProvider } from 'react-dnd';

export const GlobalStyle = createGlobalStyle`
  body, html {
    background: var(--colorBgContainer) !important;
  }
`;

export const Provider = styled(DndProvider)`
  .mobileViewer & {
    zoom: 0.5;
    width: 400px;
  }
`;

